


















































































































import { Component } from 'vue-property-decorator';
import IconMixin from '@/components/Helper/Icon/icon.mixin';
import SvgIcon from '@/components/Helper/Icon/SvgIcon.vue';

@Component<Cheeers3Icon>({
  components: { SvgIcon },
})
export default class Cheeers3Icon extends IconMixin {
  paths: string[] = [];
}
